export let MAIN_ACTION_STYLE_TYPES;
(function (MAIN_ACTION_STYLE_TYPES) {
  MAIN_ACTION_STYLE_TYPES[MAIN_ACTION_STYLE_TYPES["ICON_WITH_TEXT"] = 1] = "ICON_WITH_TEXT";
  MAIN_ACTION_STYLE_TYPES[MAIN_ACTION_STYLE_TYPES["ICON"] = 2] = "ICON";
})(MAIN_ACTION_STYLE_TYPES || (MAIN_ACTION_STYLE_TYPES = {}));
//# sourceMappingURL=main-action-style-types.js.map